import type { PageId } from "@lib/infrastructure";
import type { HereAndNowTab } from "@lib/logic";

export const HERE_AND_NOW_TAB_PAGE_IDS = {
  rooms: "hereAndNowRooms",
  workspaces: "hereAndNowWorkspaces",
  explore: "hereAndNowExplore",
} as const satisfies Record<HereAndNowTab, PageId>;
